import GenericColumn from '@isceco/widget-library2/basic-elements/List/column/GenericColumn.js'
import StringColumn from '@isceco/widget-library2/basic-elements/List/column/StringColumn.js'
import EnergyCell from '../../../components/StaticDetailList/EnergyCell'

export default class PeriodeMonitoringVNBColumns {

  static getColumns() {
    return [
      PeriodeMonitoringVNBColumns.VNB(),
      PeriodeMonitoringVNBColumns.VERFUEGUNG(),
      PeriodeMonitoringVNBColumns.KONTINGENT(),
      PeriodeMonitoringVNBColumns.VERBRAUCH(),
      PeriodeMonitoringVNBColumns.VERBRAUCH_PROZENT(),
      PeriodeMonitoringVNBColumns.UEBERSCHRITTENE()
    ]
  }

  static VNB() {
    return new StringColumn({
      key: 'vnb',
      text: 'monitoring.periode.header.vnb',
      sortable: true
    })
  }

  static VERFUEGUNG() {
    return new StringColumn({
      key: 'verfuegungen',
      text: 'monitoring.periode.header.verfuegung',
      align: 'right',
      sortable: true
    })
  }

  static KONTINGENT() {
    return new GenericColumn({
      key: 'kontingent',
      text: 'monitoring.periode.header.kontingent',
      align: 'right',
      cell: new EnergyCell(),
      sortable: true
    })
  }

  static VERBRAUCH() {
    return new GenericColumn({
      key: 'verbrauch',
      text: 'monitoring.periode.header.verbrauch',
      align: 'right',
      cell: new EnergyCell(),
      sortable: true
    })
  }

  static VERBRAUCH_PROZENT() {
    return new StringColumn({
      key: 'verbrauchProzent',
      text: 'monitoring.periode.header.verbrauchProzent',
      align: 'right',
      sortable: true
    })
  }

  static UEBERSCHRITTENE() {
    return new StringColumn({
      key: 'ueberschrittene',
      text: 'monitoring.periode.header.ueberschrittene',
      align: 'right',
      sortable: true
    })
  }

}
